"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStreamContentType = exports.fetchEventSource = void 0;
var fetch_1 = require("./fetch");
Object.defineProperty(exports, "fetchEventSource", { enumerable: true, get: function () { return fetch_1.fetchEventSource; } });
Object.defineProperty(exports, "EventStreamContentType", { enumerable: true, get: function () { return fetch_1.EventStreamContentType; } });
//# sourceMappingURL=index.js.map